module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Cake-75b26879f78db22a9d27b3b59a28af1f.svg";